<template>
    <div v-if="data">
        <div v-for="message in data" :key="message.type">
            <div
                class="my-2 p-2 shadow-md rounded-md relative flex flex-row gap-2 items-center justify-between"
                :class="[settings[message.type]?.text, settings[message.type]?.background]"
            >
                <div class="flex items-center justify-center gap-2">
                    <FontAwesomeIcon :class="settings[message.type]?.text" :icon="['fa', settings[message.type]?.icon]" />
                    <div class="text-xs" v-html="message.message"></div>
                </div>
                <div v-if="closeable" @click="close(message)" class="w-6 h-6 bg-white/30 flex-none flex justify-center items-center rounded-md cursor-pointer">
                    <FontAwesomeIcon :icon="['fa', 'times']" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Object,
        closeable: Boolean
    },

    methods: {
        close(message) {
            this.data.splice(message, 1);
            this.$emit('update:data', this.data);
        }
    },

    data: () => ({
        settings: {
            info: {
                text: 'text-white',
                background: 'bg-blue-900',
                icon: 'info-circle'
            },
            success: {
                text: 'text-white',
                background: 'bg-green',
                icon: 'check-circle'
            },
            danger: {
                text: 'text-white',
                background: 'bg-red',
                icon: 'exclamation-circle'
            },
            warning: {
                text: 'text-white',
                background: 'bg-orange-900',
                icon: 'exclamation-circle'
            }
        }
    }),

    emits: ['update:data']
};
</script>
